// extracted by mini-css-extract-plugin
module.exports = {"filesContainer":"PosDisputesFiles_filesContainer___vdBJ","filesListContainer":"PosDisputesFiles_filesListContainer__3q0Ai","filesButton":"PosDisputesFiles_filesButton__lp-It"};